/* Built-in imports */
import React, { Component } from 'react';

/* Third-party imports */
import { Trans, Translation } from 'react-i18next';
import { connect } from 'react-redux';

/* Internal imports */
import { CONTACT_EMAIL } from '../../../common/Configuration';
import { getSvgEnFonctionDuTenant, isEmailDeContactDisplayed } from '../../../services/TenantService';

class YesContact extends Component {
  getPhoneNumber = (phoneNumber) => {
    return '+33' + phoneNumber.substring(1).replace(/\s/gi, '');
  };

  getMail = () => {
    return CONTACT_EMAIL;
  };

/*
  prendreRdv = async () => {
    window.open(process.env.REACT_APP_STATIC_URL + ROUTE_PRENDRE_RDV, '_blank');
  };
*/

  render() {
    return (
      <div className="infosContactTunnel">
        {/*<button onClick={this.prendreRdv}>
          <Stack direction="row" className="prendre-rdv-container">
            <EventIcon fontSize="small" />
            Prendre rendez-vous
          </Stack>
        </button>*/}
        <Translation>
          {(t) => (
            <a href={'tel:' + this.getPhoneNumber(t('contact.telephone'))}>
              <img src={getSvgEnFonctionDuTenant('/assets/img/icons/', '/phone.svg')} alt="telephone" />
              <span>
                <Trans i18nKey="contact.telephone" />
              </span>
            </a>
          )}
        </Translation>
        {isEmailDeContactDisplayed() && (
          <div>
            <a href={'mailto:' + this.getMail()}>
              <img src={getSvgEnFonctionDuTenant('/assets/img/icons/', '/email.svg')} alt="e-mail" />
              <span>{this.getMail()}</span>
            </a>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = () => ({});
// eslint-disable-next-line no-class-assign
YesContact = connect(
  (state) => {
    const tunnel = state.tunnel;
    return { tunnel };
  },
  mapDispatchToProps()
)(YesContact);

export default YesContact;
